import React from 'react'
import PropTypes from 'prop-types'

import Video from '../Video'

function Videos({ videos = [] }) {
  if (videos?.length < 1) return null

  return videos.map((video, index) => (
    <Video key={`${video.sourceUrl}${index}`} video={video} />
  ))
}

Videos.propTypes = {
  videos: PropTypes.arrayOf(
    PropTypes.shape({
      url: PropTypes.string,
      videoType: PropTypes.string,
    })
  ),
}

export default Videos
